@defer {
  @if (widgetData()) {
    <div
      [ngClass]="theme()"
      [style.display]="megaMenuDesktopOpen() ? 'flex' : 'none'"
      class="mega-menu-desktop"
    >
      <button
        (click)="toggle()"
        aria-label="Stäng"
        class="icon-button close-button test-mega-menu-close"
        type="button"
      >
        <app-ui-icon
          class="close-icon"
          color="var(--grey-1)"
          name="close"
        ></app-ui-icon>
      </button>
      <div class="mega-menu-desktop__main-menu">
        <div class="mega-menu-desktop__main-menu__title title-5 bold">
          Hitta vård
        </div>
        <div class="mega-menu-desktop__main-menu__list">
          @for (menuItem of menuItems(); let i = $index; track menuItem) {
            <div
              (click)="selectMenuItem(i)"
              [class.body-2]="selectedItemIndex() !== i"
              [class.medium]="selectedItemIndex() === i"
              [class.regular]="selectedItemIndex() !== i"
              [class.selected]="selectedItemIndex() === i"
              [class.title-6]="selectedItemIndex() === i"
              class="mega-menu-desktop__main-menu__list-item title-6"
            >
              <div
                class="mega-menu-desktop__main-menu__list-item__label test-mega-menu-main-menu-item"
              >
                {{ menuItem }}
              </div>
              <app-ui-icon
                class="mega-menu-desktop__main-menu__list-item__icon"
                name="chevron_right"
              >
              </app-ui-icon>
            </div>
          }


          <div class="mega-menu-desktop__main-menu__popular flex flex-col gap-4">
            <div
              class="mega-menu-desktop__main-menu__popular__regular-header text-xs font-medium uppercase"
            >
              populära kategorier
            </div>

            <div
              class="mega-menu-desktop__main-menu__popular__popular-items flex gap-4 justify-start content-start flex-wrap">
              @for (item of widgetData().popularCaregiverUnitTypes; track item.id) {
                <div class="mega-menu-desktop__main-menu__popular__popular-items__pill-item inline-block">
                  <ng-container
                    *ngTemplateOutlet="pillTemplate; context: {item: this.item}"
                  ></ng-container>
                </div>
              }
            </div>
          </div>

        </div>
      </div>
      <div class="mega-menu-desktop__items">
        <div class="mega-menu-desktop__items__title title-5 bold">
          <div [ngSwitch]="selectedItemIndex()">
            <div *ngSwitchCase="0">Yrkeskategorier</div>
            <div *ngSwitchCase="1">Behandling</div>
            <div *ngSwitchCase="2">Symptom</div>
            <div *ngSwitchDefault></div>
          </div>
        </div>
        <div class="mega-menu-desktop__items__list">
          <ng-template #itemTemplate let-item="item">
            <!-- Items that has categories -->
            <div [style.display]="item.key ? 'block' : 'none'">
              <div
                class="mega-menu-desktop__items__list-item__category-label label-1"
              >
                <app-area-icon [area]="item.key"></app-area-icon>
                <span>{{ item.key }}</span>
              </div>
              <div class="mega-menu-desktop__items__list-item__grouped-list">
                @for (i of item.value; track i.id) {
                  <a
                    (click)="selectItem(i.routerLink, i.queryParams, false)"
                    [queryParams]="i.queryParams"
                    [rel]="i.noFollow ? 'nofollow' : ''"
                    [routerLink]="i.routerLink"
                    class="mega-menu-desktop__items__list-item__item-label body-2 regular test-mega-menu-item"
                  >
                    {{ i.name }}
                  </a>
                }
              </div>
            </div>

            <!-- Items without a category -->
            <div [style.display]="!item.key ? 'block' : 'none'">
              <a
                (click)="selectItem(item.routerLink, item.queryParams, false)"
                [queryParams]="item.queryParams"
                [rel]="item.noFollow ? 'nofollow' : ''"
                [routerLink]="item.routerLink"
                class="mega-menu-desktop__items__list-item__item-label body-2 regular test-mega-menu-item"
              >
                {{ item.name }}
              </a>
            </div>
          </ng-template>

          <ng-template #pillTemplate let-item="item">
            <app-ui-button
              (onClick)="selectItem(item.routerLink, item.queryParams, true)"
              [color]="'tertiary'"
              [expanded]="'pill'"
              [size]="'sm'"
              class="test-mega-menu-pill-item"
              tabindex="null"
            >
              {{ item.name }}
            </app-ui-button>
          </ng-template>

          <!-- Care service units -->
          <div
            [style.display]="selectedItemIndex() === 0 ? 'block' : 'none'"
            class="mega-menu-desktop__items__list__grid"
          >
            @for (item of widgetData().caregiverUnitTypesGrouped | keyvalue; track item.key) {
              <div class="mega-menu-desktop__items__list-item">
                <ng-container
                  *ngTemplateOutlet="itemTemplate; context: {item: this.item}"
                ></ng-container>
              </div>
            }
          </div>

          <!-- Care service types -->
          @if (appConfigService.appConfig.features.enableCareServicesInMegaMenu) {
            <div
              [style.display]="selectedItemIndex() === 1 ? 'block' : 'none'"
              class="mega-menu-desktop__items__list__grid"
            >
              @for (item of widgetData().careServiceTypesGrouped | keyvalue; track item.key) {
                <div class="mega-menu-desktop__items__list-item">
                  <ng-container
                    *ngTemplateOutlet="itemTemplate; context: {item: this.item}"
                  ></ng-container>
                </div>
              }
            </div>
          }


          <!-- Symptoms -->
          @if (appConfigService.appConfig.features.enableSymptomsInMegaMenu) {
            <div
              [style.display]="selectedItemIndex() === 2 ? 'block' : 'none'"
              class="mega-menu-desktop__items__list__grid"
            >
              @for (item of widgetData().symptomsGrouped | keyvalue; track item.key) {
                <div class="mega-menu-desktop__items__list-item">
                  <ng-container
                    *ngTemplateOutlet="itemTemplate; context: {item: this.item}"
                  ></ng-container>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }

} @placeholder (minimum 4s) {
  <div [ngClass]="theme()" class="mega-menu-desktop"
       [style.display]="megaMenuDesktopOpen() ? 'flex' : 'none'"></div>
}

@if (megaMenuDesktopOpen()) {
  <div
    @fade
    class="mega-menu-desktop-backdrop"
  ></div>
}

